import React from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { FiltersMobilePropsInterface } from './MobileType';
import * as Styled from '../FiltersStyles';
import FiltersOptions from '../FiltersOptions';
import { FiltersSearch } from '../FiltersSearch';

function FiltersMobile({ data }: Readonly<FiltersMobilePropsInterface>) {
  return (
    <Styled.WrapperFilterButtons isMobile data-testid="filters-mobile">
      <FuelFlex
        defaultProps={{
          display: 'flex',
          flexDirection: 'column',
          customMargin: '0 0 16px 0',
          gap: 'km3',
        }}
      >
        <FiltersSearch />
        <FiltersOptions data={data} />
      </FuelFlex>
    </Styled.WrapperFilterButtons>
  );
}

export default FiltersMobile;
